import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientRequirementsRoute = createRoute({
	path: '/requirements',
	getParentRoute: () => clientRoute,
});
